<div class="panel-header">
    <h2>friends</h2>
    <h5>start new conversation</h5>
    <div class="setting">
        <div class="setting-btn setting-dropdown" (clickOutside)="outSideClose()">
            <div class="btn-group custom-dropdown dropdown-sm">
                <a href="javascript:void(0)" [class.show]="isShow" (click)="isShow =!isShow">
                    <app-feather-icon [icons]="'sun'"
                        [class]="'icon-theme stroke-width-3 icon iw-11 ih-11'"></app-feather-icon>
                </a>
                <div class="dropdown-menu dropdown-menu-right custom-dropdown" [class.show]="isShow"
                    style="position: absolute; inset: 0px auto auto 0px; margin: 0px; transform: translate(-149px, 23px);">
                    <ul>
                        <li>
                            <a href="javascript:void(0)">
                                <app-feather-icon [icons]="'user'"
                                    [class]="'icon-font-light iw-16 ih-16'"></app-feather-icon>see all</a>
                        </li>
                        <li>
                            <a href="javascript:void(0)">
                                <app-feather-icon [icons]="'search'"
                                    [class]="'icon-font-light iw-16 ih-16'"></app-feather-icon>find friends</a>
                        </li>
                        <li>
                            <a href="javascript:void(0)">
                                <app-feather-icon [icons]="'settings'"
                                    [class]="'icon-font-light iw-16 ih-16'"></app-feather-icon>settings</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="search-bar">
    <div class="lg-search" >
        <app-feather-icon [icons]="'search'" [class]="'icon-theme icon iw-16'"></app-feather-icon>
        <input type="text" class="form-control" placeholder="find friends...">
    </div>
    <div class="xs-search" [class.open-full]="isOpenSearch" >
        <div class="icon-search" (click)="isOpenSearch = true">
            <app-feather-icon [icons]="'search'" [class]="'icon-dark iw-16'"></app-feather-icon>
        </div>
        <div class="lg-search">
            <app-feather-icon [icons]="'search'" [class]="'icon-dark icon iw-16'"></app-feather-icon>
            <input type="text" class="form-control" placeholder="find friends...">
            <div class="icon-close" (click)="isOpenSearch = false">
                <app-feather-icon [icons]="'x'" [class]="'icon-dark iw-16'"></app-feather-icon>
            </div>
        </div>
    </div>
</div>
@if(friendsListData){
@for (item of friendsListData; track item) {
<div class="friend-section">
    <div class="header-section">
        <a role="button" (click)="collapse.toggle()" [attr.aria-expanded]="!item.isCollapsed">{{item.heading}}
            <div class="down-arrow">
                <app-feather-icon [icons]="'chevron-down'" [class]="'icon-theme iw-14 ih-14'"></app-feather-icon>
            </div>
        </a>
    </div>
    <div id="accordion" class="friend-list collapse show" #collapse="ngbCollapse" [(ngbCollapse)]="item.isCollapsed">
        <ul>
            @for (item of item.data; track item) {
            <li class="friend-box {{item.class}}">
                <div class="media">
                    <a class="popover-cls user-img" #data="ngbPopover" [ngbPopover]="popContent" triggers="" 
                        (click)="commonServices.toggle(data, item.image , item.title, 'item.id')" placement="left"
                        [ngStyle]="{'background-image': 'url(' +  item.image  + ')'}"
                        style="background-size: cover; background-position: center center; background-repeat: no-repeat; display: block;">
                        <img [src]="item.image" class="img-fluid  bg-img" alt="user" style="display: none;">
                        <span class="available-stats {{item.status}}"></span>
                    </a>
                    <div class="media-body">
                        <h5 class="user-name">{{item.title}}</h5>
                        <h6>{{item.city}}</h6>
                    </div>
                </div>
            </li>
            }
        </ul>
    </div>
</div>
}
}
<ng-template #popContent>
    <app-popover-loader [data]="commonServices.popoverData"></app-popover-loader>
</ng-template>

@if(commonServices.isShow){
    <app-chat-box></app-chat-box>
}
